import {
  LOAD_PROJECTS,
  ADD_PROJECT_SUCCESS,
  ADD_PROJECT_FAIL,
  UPDATE_PROJECT_STATUS,
} from "./projectActions";

const initialState = {
  projects: [],
  error: null,
};

export default function projectReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case LOAD_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };

    case ADD_PROJECT_SUCCESS:
      return {
        ...state,
        projects: [
          ...state.projects,
          action.payload,
        ],
      };

    case ADD_PROJECT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_PROJECT_STATUS:
      return {
        ...state,
        projects: state.projects.map(
          (project) =>
            project.id ===
            action.payload.projectId
              ? {
                  ...project,
                  status:
                    action.payload.status,
                }
              : project
        ),
      };

    default:
      return state;
  }
}